var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppMediaEncoder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#00005B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6143 14.4297L16.9077 26.2705L20.46 14.4297H28.1934L29.7476 39.2214H23.124L22.791 29.7859C22.7168 27.4177 22.6431 25.0496 22.5693 22.6443L18.832 37.2974H14.3916L11.0982 23.3843C10.9873 25.5305 10.9131 27.6765 10.8389 29.7859L10.3955 39.2214H4.17871L5.80664 14.4297H13.6143Z",
    fill: "#9999FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.415 29.0088C50.415 29.8967 50.3408 30.8589 50.23 31.5989H38.1299C38.8701 33.449 40.6465 34.3372 43.4219 34.3372C45.4199 34.3372 47.1587 33.967 48.8979 33.1531L48.9717 38.2964C47.085 39.2585 45.0498 39.5916 42.4224 39.5916C35.9473 39.5916 31.6177 36.0022 31.6177 29.4897C31.6177 23.5325 35.7617 19.573 41.2383 19.573C46.8628 19.573 50.415 23.1992 50.415 29.0088ZM37.9082 27.3806H44.3838C44.2354 25.6416 43.1626 24.4204 41.2754 24.4204C39.4624 24.4204 38.3154 25.3826 37.9082 27.3806Z",
    fill: "#9999FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppMediaEncoder);
export default __webpack_public_path__ + "static/media/B_app_MediaEncoder.264fce35d5ceaa9a69526ab4b07adcc0.svg";
export { ForwardRef as ReactComponent };